import { useEffect, useState } from "react";
import { useData } from "../context/Data";
import { api } from "../lib/api";
import { eur, CATEGORY } from "../lib/fmt";
import { Spinner, Micro, DemoMark } from "../components/common";

function Bars({ rows, label, testid }) {
  const max = Math.max(1, ...rows.map((r) => r.amount));
  const [ready, setReady] = useState(false);
  useEffect(() => { const t = setTimeout(() => setReady(true), 80); return () => clearTimeout(t); }, []);
  return (
    <div className="metric-bars" style={{ gridTemplateColumns: `repeat(${rows.length || 1}, minmax(0,1fr))` }} role="img" aria-label={label} data-testid={testid}>
      {rows.map((r) => (
        <div className="metric-col" key={r.k}><small>{r.amount ? eur(r.amount).replace(",00", "") : ""}</small><div className="bar-track"><span className="bar-value" style={{ height: ready ? `${(r.amount / max) * 100}%` : 3 }} /></div><span>{r.label}</span></div>
      ))}
    </div>
  );
}

export default function Estadisticas() {
  const { d } = useData();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/me/stats").then(({ data }) => setS(data)).catch(() => {}); }, [d]);
  if (!s) return <Spinner />;
  const days = s.last7.map((x) => ({ k: x.day, amount: x.amount, label: new Date(x.day + "T12:00:00").toLocaleDateString("es-ES", { weekday: "short" }) }));
  const weeks = s.weeks.map((x) => ({ k: x.week, amount: x.amount, label: x.week.slice(5).split("-").reverse().join("/") }));
  const catMax = Math.max(1, ...s.categories.map((c) => c.amount));
  return (
    <>
      <div className="page-intro"><div className="eyebrow">ANALÍTICAS PERSONALES</div><h1>📊 Mis estadísticas</h1><p className="lead">Resumen calculado a partir de tus movimientos reales en el libro mayor de la plataforma.</p></div>
      <div className="kpi-strip"><div className="kpi-tile"><span className="stat-label">Hoy</span><b className="lime" data-testid="earned-day">{eur(s.day)}</b></div><div className="kpi-tile"><span className="stat-label">Esta semana</span><b data-testid="earned-week">{eur(s.week)}</b></div><div className="kpi-tile"><span className="stat-label">Este mes</span><b data-testid="earned-month">{eur(s.month)}</b></div></div>
      <div className="split" style={{ marginTop: 18 }}>
        <article className="card"><div className="flex"><h2>📅 Últimos 7 días</h2><DemoMark mode={d.config.mode} /></div><Bars rows={days} label="Recompensas de los últimos siete días" testid="week-bars" /></article>
        <article className="card"><h2>🧩 De dónde vienen</h2>
          {s.categories.length === 0 ? <div className="empty">Aún no hay recompensas.</div> : s.categories.map((c) => (
            <div className="category-row" key={c.category}><div className="category-label"><span>{CATEGORY[c.category] || c.category}</span><b>{eur(c.amount)}</b></div><Micro pct={(c.amount / catMax) * 100} /></div>
          ))}</article>
      </div>
      <div className="card" style={{ marginTop: 18 }}><h2>📈 Evolución semanal</h2><Bars rows={weeks} label="Recompensas por semana" testid="weekly-bars" /></div>
      <div className="card" style={{ marginTop: 18 }}><h2>Actividad acumulada</h2><div className="kpi-strip">
        <div className="kpi-tile"><span>👥 Referidos válidos</span><b>{d.valid_refs}</b></div><div className="kpi-tile"><span>📝 Encuestas</span><b data-testid="stat-surveys">{s.activity.survey}</b></div><div className="kpi-tile"><span>📅 Check-ins</span><b>{s.activity.checkin}</b></div>
        <div className="kpi-tile"><span>📺 Vídeos</span><b>{s.activity.video}</b></div><div className="kpi-tile"><span>🎮 Minijuegos</span><b>{s.activity.game}</b></div><div className="kpi-tile"><span>🌐 Campañas</span><b>{s.activity.site}</b></div>
      </div></div>
    </>
  );
}
